import Stake from "./Stake";

export default Stake;
